import Axios from "axios";
import { memberUrls } from "../urls";
import router from "../../../router";

export default {
  get_all_members(context) {
    Axios.get(memberUrls.getAllMembers).then(function (response) {
      context.commit("GET_ALL_MEMBERS", response.data);
    });
  },
  get_all_booking_members(context) {
    Axios.get(memberUrls.getAllBookingMembers).then(function(response) {
      context.commit("GET_ALL_MEMBERS", response.data);
    });
  },
  get_all_corporate_members(context) {
    Axios.get(memberUrls.getAllCorporateMembers).then(function(response) {
      context.commit("GET_CORPORATE_MEMBERS", response.data);
    });
  },

  remind_membership_payment(context, publicId) {
    Axios.get(memberUrls.remindMembershipPayment + publicId).then(function(
      response
    ) {});
  },
  update_member_beneficiary(context, data) {
    Axios.patch(memberUrls.updateBeneficiary + data.public_id, data).then(
      () => {
        context.dispatch("get_member", data.member_id);
        // router.push({ name: 'Member', params: { member_id: data.member_id } })
      }
    );
  },
  delete_member_beneficiary(context, data) {
    Axios.get(memberUrls.deleteMemberBeneficiary + data.public_id).then(() => {
      context.dispatch("get_member", data.member_id);
    });
  },
  add_member_beneficiary(context, data) {
    Axios.post(memberUrls.addBeneficiary, data).then(() => {
      context.dispatch("get_member", data.member_id);
    });
  },
  get_members(context, publicId) {
    Axios.get(memberUrls.getMembers + publicId).then(function(response) {
      context.commit("GET_MEMBERS", response.data);
    });
  },
  get_deleted_members(context) {
    Axios.get(memberUrls.getDeletedMember).then(function(response) {
      context.commit("GET_DELETED_MEMBERS", response.data);
    });
  },
  get_member(context, publicId) {
    Axios.get(memberUrls.getMember + publicId).then(function(response) {
      context.commit("GET_MEMBER", response.data);
      context.dispatch("get_member_visits", response.data.member_id);
    });
  },
  get_corporate_member(context, publicId) {
    Axios.get(memberUrls.getCorporateMember + publicId).then(function(
      response
    ) {
      context.commit("GET_CORPORATE_MEMBER", response.data);
      context.dispatch("get_member_visits", response.data.memberID);
    });
  },
  get_member_visits(context, memberId) {
    Axios.get(memberUrls.getMemberVisits + memberId).then(function(response) {
      context.commit("GET_MEMBER_VISITS", response.data);

    });
  },
  post_corporate_member(context, data) {
    Axios.post(memberUrls.addCorporateMember, data).then(response => {
      if (response.status === 200) {
        router.push({
          name: "Members"
        });
      }
    });
  },
  member_request_mpesa(context, data) {
    Axios.post(memberUrls.requestMpesa, data)
      .then(function() {})
      .catch(function(error) {
        context.commit("UPDATE_ERRORS", error.data);
      });
  },
  post_member(context, data) {
    Axios.post(memberUrls.postMember, data)
      .then(function() {
        context.dispatch("get_all_members");
        router.push({
          name: data.redirect_url
        });
      })
      .catch(function(error) {});
  },
  // update_member(context, data) {
  //   Axios.post(memberUrls.editMember + data.public_id, data).then(function() {
  //     context.dispatch("get_member", data.public_id);
  //     context.dispatch("get_all_members");
  //     router.push({
  //       name: data.redirect_url
  //     });
  //   });
  // },
  update_corporate_member(context, data) {
    Axios.patch(memberUrls.editCorporateMember,data).then(
      function() {
        // context.dispatch("get_corporate_member", data.member_id);
        context.dispatch("get_all_corporate_members");
        router.push({
          name: data.redirect_url
        });
      }
    );
  },
  // delete_member(context, publicId) {
  //   Axios.get(memberUrls.deleteMember + publicId).then(function(response) {
  //     alert(response.data.message);
  //     context.commit("GET_DELETED_MEMBERS", response.data);
  //     router.push({
  //       name: "Module.DeletedMembers"
  //     });
  //   });
  // },
  restoreMember(context, publicId) {
    Axios.get(memberUrls.restoreMember + publicId).then(function(response) {
      alert(response.data.message);
      context.commit("GET_ALL_MEMBERS", response.data);
      router.push({
        name: "Module.Members"
      });
    });
  }
};
